<template>
	<!-- Custom Vue Material Radio Group wrapper component-->
	<!--
		The model for the radiogroup is added as v-model prop to this component, but setting and getting value
		is done from the child component. The value prop here is kept as reference.
	-->
	<div>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "RadioGroup",
	props: {
		value: {
			type: [String, Number, Boolean],
			required: true
		}
	}
};
</script>
